import { defaultColumns, defaultSort } from '../../components/sales/invoiceBooks/columns';

export default {
  state: {
    invoiceBooks: [],
    lastSelected: null,
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    invoiceBooks: state => state.invoiceBooks,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
    lastSelected: state => state.lastSelected,
  },
  mutations: {
    setInvoiceBooks(state, invoiceBooks) {
      state.invoiceBooks = invoiceBooks;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setLastSelected(state, selected) {
      state.lastSelected = selected;
    }
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/invoice-book-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'invoice-book-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'invoice-book-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const invoiceBooks = await axios.get('api/invoice-books' + (query || ''));
        commit('setInvoiceBooks', invoiceBooks);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/invoice-books/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/invoice-books', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/invoice-books', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/invoice-books/${id}`);
    },
  },
};
